/* Lightweight scroll-reveal via IntersectionObserver. Respects prefers-reduced-motion. */
(function () {
  'use strict';

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initReveal(root) {
    root = root || document;
    var enabled = document.body.getAttribute('data-animations-enabled') !== 'false';
    var items = root.querySelectorAll('[data-animate]:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion() || !('IntersectionObserver' in window) || !enabled) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var group = entry.target.closest('[data-animate-stagger]');
        if (group) {
          var siblings = Array.prototype.slice.call(group.querySelectorAll('[data-animate]'));
          siblings.forEach(function (el, i) { el.style.setProperty('--stagger-index', i); });
        }
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { initReveal(document); });
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
